import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section
      className="py-24 md:py-32 bg-[#1e3a5f] relative overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_white_1px,_transparent_1px)] bg-[length:40px_40px]" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
            {t('cta_title') || 'Ready to Comply with VeriFactu?'}
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
            {t('cta_subtitle') || 'Join hundreds of Spanish businesses that are already prepared'}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/register?plan=pos"
              className="inline-flex items-center justify-center gap-2 bg-[#22c55e] text-white px-8 py-4 text-lg font-bold border-2 border-white/20 hover:bg-[#16a34a] transition-all"
              data-testid="cta-main-button"
            >
              {t('hero_cta_pos') || 'Full POS \u20AC19.99/mo'}
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/register?plan=invoice"
              className="inline-flex items-center justify-center gap-2 bg-white/10 text-white px-8 py-4 text-lg font-bold border-2 border-white/20 hover:bg-white/20 transition-all"
              data-testid="cta-secondary-button"
            >
              {t('hero_cta_invoice') || 'Invoices Only \u20AC4.99/mo'}
            </Link>
          </div>

          {/* Trust Elements */}
          <div className="flex flex-wrap items-center justify-center gap-8 text-white/60">
            {[
              t('cta_trust_1') || '14-day free trial',
              t('cta_trust_2') || 'No credit card required',
              t('cta_trust_3') || 'Cancel anytime',
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <Check className="w-4 h-4 text-[#22c55e]" />
                <span className="text-sm">{item}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
